// src/features/admin/ExportPanel.jsx
//
// ADMIN-DATA-RATIONALIZE: Renamed to "Backup & restore". The existing
// Download JSON export is unchanged. A new "Restore from JSON" section
// reuses MigrationPanel with mode="restore" — same two-step validate+run
// flow, same conflict-rollback behaviour, relabelled copy only.

import React, { useState } from "react";
import { downloadLocationsJson } from "../../utils/exportJson.js";
import { ErrorBanner } from "../../components/ErrorBanner.jsx";
import { DataTabHeading } from "../../components/DataTabHeading.jsx";
import { T } from "../../app/tokens.js";
import { log } from "../../utils/logger.js";
import { showToast } from "../../components/toastService.jsx";
import { MigrationPanel } from "./MigrationPanel.jsx";

const DIVIDER = {
  border: "none",
  borderTop: `0.5px solid ${T.border}`,
  margin: "28px 0",
};

const PRIMARY_BUTTON = {
  background: T.blue, color: T.white, border: "none", borderRadius: 6,
  fontSize: T.fsSm, fontWeight: T.fwBold, padding: "7px 14px", cursor: "pointer",
};
const PRIMARY_BUTTON_DISABLED = {
  ...PRIMARY_BUTTON,
  opacity: 0.6, cursor: "not-allowed",
};

export function ExportPanel() {
  const [busy,  setBusy]  = useState(false);
  const [error, setError] = useState(null);

  const onClick = async () => {
    setError(null);
    setBusy(true);
    log.audit("export.portfolio.start", {});
    try {
      const payload = await downloadLocationsJson();
      log.audit("export.portfolio.success", {
        locations: payload?.locations?.length ?? 0,
      });
      showToast("Export downloaded.", { type: "success" });
    } catch (err) {
      log.error("ExportPanel download failed", { name: err?.name, msg: err?.message });
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="export-panel">
      <DataTabHeading
        description="Download all locations and their nested data (leases, allowances, draws, critical dates, watch items, commentary, candidates, headcount snapshots, utilization, location costs) as a JSON file. Used for backup, audit, or data analysis."
      >
        Backup &amp; restore
      </DataTabHeading>
      <div style={{
        fontSize: T.fsXs, color: T.light, fontStyle: "italic",
        lineHeight: 1.5, marginBottom: 18,
      }}>
        Generates one round-trip per location. For 44 locations expect
        a 5-15 second download time.
      </div>

      <ErrorBanner error={error} onDismiss={() => setError(null)} />

      <button
        type="button"
        data-testid="export-portfolio-button"
        disabled={busy}
        onClick={onClick}
        style={busy ? PRIMARY_BUTTON_DISABLED : PRIMARY_BUTTON}
      >
        {busy ? "Generating…" : "Download JSON"}
      </button>

      <hr style={DIVIDER} />

      <MigrationPanel mode="restore" />
    </div>
  );
}
